import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: 'emptyProductVendor',
  props: {
    products: {
      type: Array,
      default() {
        return []
      }
    }
  },
  //---components
  components: {},
  //---data
  data () {
    return {
      isShow: null,
    }
  },
  //---hooks
  created() {
    this.isShow = true;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      popupStore: 'system/popupStore',
    }),
  },
  watch: {},
  //---methods
  methods: {
    ...mapMutations({
      closePopup: 'system/SYSTEM_POPUP_CLOSE',
    }),
    ...mapActions({}),
    close() {
      this.isShow = false;
      setTimeout(()=>{
        this.closePopup('emptyProductVendor');
      },400);
    },
    confirm() {
      this.$emit('confirm');
    },
  }
}